import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Shows from './components/Shows';
import Videos from './components/Videos';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminPanel from './pages/AdminPanel';
import AdminLogin from './pages/AdminLogin';
import { Toaster } from './components/ui/sonner';
import { bioData, videoCategories, services, galleryPhotos } from './data/mockData';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadShows();
  }, []);

  const loadShows = async () => {
    try {
      const response = await axios.get(`${API}/shows`);
      setShows(response.data);
    } catch (error) {
      console.error('Error loading shows:', error);
      // Fallback to empty array if API fails
      setShows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Hero bioData={bioData} />
      <About bioData={bioData} />
      <Gallery photos={galleryPhotos} />
      <Shows shows={shows} loading={loading} />
      <Videos videoCategories={videoCategories} instagramUrl={bioData.instagramUrl} />
      <Services services={services} />
      <Contact bioData={bioData} />
      <Footer bioData={bioData} />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
